import { EventEmitter, Injectable } from '@angular/core';

export interface MosItemEvent {
    storyGuid: string;
    mosCommand: string;
}

@Injectable({
    providedIn: 'root',
})
export class MosEventService {
    private mosItemEmitter = new EventEmitter<MosItemEvent>();

    emitMosItem(event: MosItemEvent) {
        this.mosItemEmitter.emit(event);
    }

    onMosItem() {
        return this.mosItemEmitter;
    }
}
